import Image from 'next/image';
import Link from 'next/link';
import { useEffect } from "react";
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';


export default function eventBox(props) {
  // 모듈러 링크 리액트 hook
  useEffect(() => {
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를
  const handleClick = (a, b, c) => {
    let conver_current_s = (parseInt(props.currentSlide) + 1);
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '상단영역 이벤트형',
        clickType: 'NC',
        value1: b.pc_img_attr,
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };


  return (
    <div className="swiper-slide slide-slide">
      <div className="swiper-cont">
        {/* <!-- 이벤트형 --> */}
        {
          props.data.contents.map((item, index) => {
            if (item.type == 'EVENT') {
              return (
                <div key={'mte_' + index} className="spotModuleWrap_event">
                  {
                    item.link_url == null || item.link_url == ''
                      ? (
                        <>
                          <Image src={item.pc_img_url} className="spotModuleImg" layout='fill' quality={item.imageQuality || 100} alt={item.pc_img_attr} />
                        </>
                      )
                      :
                      (
                        <>
                          <a
                              href={item.link_url}
                              onClick={(e) => handleClick(e, item, 'event')}
                              target={item.link_new_yn === 'Y' ? '_blank' : undefined}
                              rel={item.link_new_yn === 'Y' ? 'noopener noreferrer' : undefined}
                              className="spotModuleImage_w"
                          >
                            <Image
                                src={item.pc_img_url}
                                className="spotModuleImg"
                                layout="fill"
                                quality={item.imageQuality || 100}
                                alt={item.pc_img_attr}
                            />
                          </a>
                        </>
                      )
                  }
                </div>
              );
            }
          })

        }

      </div>
    </div >
  );
}
